export default __webpack_public_path__ + "static/media/avax-disable.151a89ef.svg";